import { React, useEffect, useState } from "react";
import { Header } from "./../Header";
// import { Layout } from "./Layout";
import { Link } from "react-router-dom";
import { Sidebar } from "../Sidebar";
import axios from "axios";
import { base_url } from "../../context/Authcontext";
import { formatINR } from "../../utils/money";
export const Depositereport = () => {


  const [isSidebar, setSidebar] = useState(false);
  const [withdrawHistory, setWithdrawHistory] = useState([]); // Initialize as an empty array
  const [loading, setLoading] = useState(true); // Add a loading state
  const [error, setError] = useState(null);   // Add an error state
  useEffect(() => {
    const fetchDepositHistory = async () => {  // Renamed function for clarity
        setLoading(true);
        setError(null);

        try {
            const res = await axios.post(
                `${base_url}/api/webapi/withdraw/historyListDeposit`, // Correct API endpoint
                {}, // Corrected: Empty object for request body
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );

            console.log("Full response:", res);

            if (res.data && res.data.depositList) { // Use depositList to match server
                setWithdrawHistory(res.data.depositList); // Correct state variable
            } else {
                console.error("Invalid response format:", res.data);
                setError("Invalid data format from the server.");
            }

        } catch (err) {
            console.error("Error fetching deposit history:", err);
            setError("A network error occurred. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    fetchDepositHistory(); // Call the renamed function
}, []);

if (loading) {
    return <div>Loading deposit history...</div>;
}

if (error) {
    return <div>Error: {error}</div>;
}


  return (
    <>
      <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
      <Header isSidebar={isSidebar} setSidebar={setSidebar} />
      <div
        _ngcontent-hdd-c80=""
        className=""
      >
        <app-reports _nghost-hdd-c162="" className="ng-star-inserted">
          <div _ngcontent-hdd-c162="" className="pcoded-main-container">
            <div
              _ngcontent-hdd-c162=""
              className="container-fluid pl-3 accounts-box"
            >
              <div _ngcontent-hdd-c162="" className="row account-tabs"   style={{height:"617px"}}>
             
                <div
                  _ngcontent-oqs-c169=""
                  className="col-12 mt-5 px-1 centralized_css"
                >
                  <app-history-home _nghost-oqs-c183="">
                    <div _ngcontent-oqs-c183="">
                      <div
                        _ngcontent-oqs-c183=""
                        className="col-md-12 deposit-pad-mob"
                      >
                        <div
                          _ngcontent-oqs-c183=""
                          className="st_blog_detail withdraw_section"
                        >
                          <div
                            _ngcontent-oqs-c183=""
                            className="st_featured_thumb"
                          >
                            <div
                              _ngcontent-oqs-c183=""
                              className="depositTabsWrapper d-flex justify-content-center"
                            >
                              <Link
                                to="/withdrawhistory"
                                _ngcontent-oqs-c183=""
                                routerlinkactive="activeTab"
                                className="st_hd1"
                                tabIndex="0"
                              >
                                <span
                                  _ngcontent-oqs-c183=""
                                  style={{ right: "6px" }}
                                >
                                  Withdrawal History
                                </span>
                              </Link>
                              <div
                                _ngcontent-oqs-c183=""
                                routerlinkactive="activeTab"
                                className="st_hd1 activeTab"
                                tabIndex="0"
                              >
                                <span _ngcontent-oqs-c183="">
                                  Deposit History
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <router-outlet _ngcontent-oqs-c183=""></router-outlet>
                      <app-deposit-history _nghost-oqs-c182="">
                        <div
                          _ngcontent-hdd-c162=""
                          className="search-table"
                          style={{ paddingTop: "50px" }}
                        >
                          <div
                            _ngcontent-hdd-c162=""
                            className="table-box no-more-tables"
                          >
                            <table
                              _ngcontent-hdd-c162=""
                              className="table-borderless"
                            >
                              <thead _ngcontent-hdd-c162="">
                                <tr _ngcontent-hdd-c162="">
                                  <th _ngcontent-hdd-c162="" className="text-left">
                                    Amount
                                  </th>
                                  <th _ngcontent-hdd-c162="" className="text-center">
                                    Bonus
                                  </th>
                                  <th _ngcontent-hdd-c162="" className="text-center">
                                    Total Credited
                                  </th>
                                  <th _ngcontent-hdd-c162="" className="text-center">
                                    Time
                                  </th>
                                  <th _ngcontent-hdd-c162="" className="text-center">
                                    Status
                                  </th>
                                </tr>
                              </thead>
                              <tbody _ngcontent-hdd-c162="">
                {withdrawHistory.map((deposit, index) => {
                    const bonus = Number(deposit.bonus_money) || 0;
                    const total = Number(deposit.money) + (deposit.status === 1 ? bonus : 0);
                    return (
                    <tr key={index} _ngcontent-hdd-c162="" className="xg-bet-tr">
                        <td _ngcontent-hdd-c162="" className="text-left" data-title="Amount">
                            {formatINR(deposit.money)}
                        </td>
                        <td _ngcontent-hdd-c162="" className="text-center" data-title="Bonus">
                            {deposit.status === 1 && bonus > 0 ? formatINR(bonus) : "—"}
                        </td>
                        <td _ngcontent-hdd-c162="" className="text-center" data-title="Total Credited">
                            {deposit.status === 1 ? formatINR(total) : "—"}
                        </td>
                        <td _ngcontent-hdd-c162="" className="text-center" data-title="Upload Date">
                            {deposit.today || deposit.requestTime}
                        </td>
                        <td _ngcontent-hdd-c162="" className="text-center text-white p-2" data-title="Verified">
                        <span _ngcontent-hdd-c162="" className={deposit.status === 1? "approved-status": deposit.status === 0 ? "" : "rejected-status"}>
    {deposit.status === 1? "Approved" : deposit.status === 0 ? "Pending" : "Rejected"}
</span>
                        </td>
                    </tr>
                    );
                })}
            </tbody>
                            </table>
                          </div>
                        </div>
                      </app-deposit-history>
                    </div>
                  </app-history-home>
                </div>
              </div>
            </div>
          </div>
        </app-reports>
      </div>
    </>
  );
};